export default "__VITE_ASSET__BB5mF$Zu__"